import {useEffect, useRef} from 'react';

export const useFocusOnMount = <T extends HTMLElement>(enabled = true) => {
    const ref = useRef<T>(null);
    useEffect(() => {
        if (enabled) {
            ref.current?.focus({preventScroll: true});
        }
    }, [enabled]);
    return ref;
};
